/**
 * Shared seat-arrangement overlay logic (widget side).
 *
 * An arrangement stores per-seat overrides (svgInfo) and can mark a seat as
 * `removed` (excluded from that layout). Applying the overlay produces the
 * display elements (positions/model overridden) and the excluded seat ids, so
 * every guest-facing map renders the active arrangement identically.
 */

export function buildPositionMap(
    positions: { seatId: number; svgInfo: any }[] | undefined,
): Record<number, any> {
    const posMap: Record<number, any> = {};
    for (const p of positions || []) {
        posMap[p.seatId] = p.svgInfo;
    }
    return posMap;
}

export function applyArrangementOverlay<T extends { id: number }>(
    elements: T[],
    posMap: Record<number, any>,
): { displayElements: T[]; excludedSeatIds: number[] } {
    const displayElements: T[] = [];
    const excludedSeatIds: number[] = [];
    for (const el of elements) {
        const pos = posMap[el.id];
        if (pos?.removed === true) {
            excludedSeatIds.push(el.id);
            continue;
        }
        if (!pos) {
            displayElements.push(el);
            continue;
        }
        const e = el as any;
        displayElements.push({
            ...el,
            x: pos.x ?? e.x,
            y: pos.y ?? e.y,
            rotation: pos.rotation ?? e.rotation,
            scale: pos.scale ?? e.scale,
            model: pos.model || e.model,
            svg: pos.svg || e.svg,
        });
    }
    return { displayElements, excludedSeatIds };
}
